import React, { useState } from 'react';
import { is1024andSmaller } from 'swag-client-common/utils/ui.utils';
import BottomButtons from '../bottom-buttons';
import css from './box-naming.scss';
const BoxNaming = ({
  boxName,
  canGoBackwards,
  onClose,
  onBackButton,
  onChange,
  onSave,
  hasUnsavedChanges,
  isEdit
}) => {
  const [name, setName] = useState(boxName || '');
  const title = isEdit ? 'Edit name for your box' : 'Create a name for your box!';
  const onBackHandler = canGoBackwards ? onBackButton : () => onClose(hasUnsavedChanges);
  const backText = canGoBackwards && !isEdit ? 'Back' : 'Cancel';
  const nextText = isEdit ? 'Save' : 'Continue';
  const placeholder = is1024andSmaller() ? 'Enter box name here' : 'Enter your box name here';
  const handleChange = e => {
    const {
      value
    } = e.target;
    setName(value);
    onChange(value);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: css.boxNamingWrapper
  }, /*#__PURE__*/React.createElement("header", {
    className: css.header
  }, title), /*#__PURE__*/React.createElement("p", {
    className: css.text
  }, "For example, you might want to call this \u201Cwelcome box\u201D or \u201Ccustomer appreciation box\u201D so that you can identify the box more easily!"), /*#__PURE__*/React.createElement("input", {
    "data-input": "BoxName",
    className: css.input,
    type: "text",
    value: name,
    onChange: handleChange,
    placeholder: placeholder
  }), /*#__PURE__*/React.createElement(BottomButtons
  // @todo. auto generated. fix this error
  // @ts-ignore
  , {
    buttonsWrapperClassName: css.buttons,
    onBackButton: onBackHandler,
    isDisabledNextButton: !name.trim().length,
    onNextButton: () => onSave(name, isEdit),
    nextText: nextText,
    backText: backText
  }));
};
export default BoxNaming;